import Vue from 'vue'
import store from '@/store'

function toArray (val) {
  let arr = []
  if ((typeof val) === 'object') {
    if (Array.isArray(val)) {
      arr = val
    } else {
      arr.push(val)
    }
  } else {
    console.error('toArray: Unexpected datatype')
  }
  return arr
}

const enrichBooking = function (val, appends) {
  const bookings = toArray(val)
  window.conversion.convertDates('Booking', bookings)
  bookings.forEach(booking => {
    booking.title = booking.type === 'season' ? `Säsongsbokning ${booking.booking_number}` : `Bokning ${booking.booking_number}`
    booking.daysFormatted = window.conversion.diffInDays(booking.check_in, booking.check_out)
    if (booking.season_id) {
      booking.season = store.state.season.seasons.find(season => season.id === booking.season_id) // season.seasons innehåller också deleted_at seasons
    }
    if (booking.season) {
      booking.subtitle = `${booking.season.full_name}, ${booking.daysFormatted}`
    } else {
      booking.subtitle = booking.daysFormatted
    }
    booking.position = store.state.position.positions.find(pos => pos.id === booking.position_id)
    booking.category = store.state.position.categories.find(cat => cat.id === booking.category_id)
    booking.channel = store.state.staticData.channels.find(channel => channel.id === booking.channel_id)
    if (booking.cancellation_policy_id) {
      booking.cancellationPolicy = store.state.cancellationPolicy.cancellationPolicies.find(policy => policy.id === booking.cancellation_policy_id)
    }
    booking.lodgingType = store.state.position.lodgingTypes.find(type => type.id === booking.lodging_type_id)
    if (booking.customer) {
      enrichCustomer(booking.customer)
    } else if (appends && appends.customer) {
      booking.customer = appends.customer
    }
    if (booking.expected_arrival_time !== null) {
      booking.expected_arrival_time = booking.expected_arrival_time.slice(0, 5)
    }
    if (!booking.checked_out_at) {
      booking.should_checkout_at = booking.check_out.clone().hour(booking.category.check_out_time.slice(0, 2)).minute(booking.category.check_out_time.slice(3, 5))
    } else {
      booking.should_checkout_at = null
    }

    // Samma färger används också i BookingsTable och CancellationsTable (bokningarna där berikas inte)
    booking.status = null
    booking.statusText = null
    booking.statusColor = null
    if (booking.deleted_at) {
      booking.status = 'canceled'
      booking.statusText = 'Avbokad'
      booking.statusColor = 'error'
    } else if (booking.checked_out_at) {
      booking.status = 'checked_out'
      booking.statusText = 'Utcheckad'
      booking.statusColor = 'primary'
    } else if (booking.checked_in_at) {
      booking.status = 'checked_in'
      booking.statusText = 'Incheckad'
      booking.statusColor = 'success'
    } else {
      booking.status = 'upcoming'
      booking.statusText = 'Kommande'
      booking.statusColor = 'info'
    }

    booking.isEnriched = true
  })
}

const enrichBookingGroup = function (val, appends) {
  const bookingGroups = toArray(val)
  window.conversion.convertDates('BookingGroup', bookingGroups)
  bookingGroups.forEach(bookingGroup => {
    bookingGroup.title = bookingGroup.name ? `Gruppbokning ${bookingGroup.name} (${bookingGroup.booking_number})` : `Gruppbokning ${bookingGroup.booking_number}`
    bookingGroup.channel = store.state.staticData.channels.find(channel => channel.id === bookingGroup.channel_id)
    if (bookingGroup.customer) {
      enrichCustomer(bookingGroup.customer)
    } else if (appends && appends.customer) {
      bookingGroup.customer = appends.customer
    }
    bookingGroup.bookings.forEach(booking => {
      enrichBooking(booking)
    })

    // Kollar om finns mer än en kund kopplat till gruppbokningen
    bookingGroup.hasMultipleCustomers = new Set([
      bookingGroup.customer_id,
      ...bookingGroup.bookings.map(booking => booking.customer_id)
    ]).size > 1

    if (bookingGroup.nights === 1) {
      bookingGroup.daysFormatted = '1 natt'
    } else {
      bookingGroup.daysFormatted = `${bookingGroup.nights} nätter`
    }
    bookingGroup.subtitle = `${bookingGroup.bookings.length} bokningar, ${bookingGroup.daysFormatted}`
    bookingGroup.isEnriched = true
  })
}

const enrichInvoice = function (val) {
  const invoices = toArray(val)
  window.conversion.convertDates('Invoice', invoices)
  invoices.forEach(invoice => {
    invoice.totalFormatted = window.conversion.toHumanReadableAmount(invoice.total_amount / 100)
    invoice.remainingAmountFormatted = window.conversion.toHumanReadableAmount(invoice.remaining_amount / 100)
    invoice.createdAtFormatted = invoice.created_at.format('D MMM YYYY')
    invoice.dueDateFormatted = invoice.due_date.format('D MMM YYYY')

    if (invoice.payment_term_id) {
      invoice.paymentTerm = store.state.invoice.paymentTerms.find(pt => pt.id === invoice.payment_term_id)
    }
    if (invoice.customer) {
      enrichCustomer(invoice.customer)
    }
    if (invoice.emails) {
      enrichEmail(invoice.emails)
    }

    const today = window.dayjs.today()
    invoice.isOverdue = !invoice.is_credit_invoice && invoice.status !== 'closed' && invoice.due_date.isBefore(today)
    invoice.isOverdueDeposit = !invoice.is_credit_invoice && invoice.status !== 'closed' && invoice.deposit_amount && invoice.paid_amount < invoice.deposit_amount && invoice.deposit_due_date.isBefore(today)

    if (invoice.isOverdue) {
      invoice.statusText = 'Förfallen'
      invoice.statusColor = 'error'
    } else if (invoice.isOverdueDeposit) {
      invoice.statusText = 'Förfallen handpenning'
      invoice.statusColor = 'error'
    } else if (invoice.status === 'open') {
      invoice.statusText = 'Obetald'
      invoice.statusColor = 'info'
    } else if (invoice.status === 'partial') {
      invoice.statusText = 'Delbetald'
      invoice.statusColor = 'info'
    } else if (invoice.status === 'closed') {
      invoice.statusText = 'Betald'
      invoice.statusColor = 'success'
    }

    invoice.isEnriched = true
  })
}

const enrichCountry = function (val) {
  const countries = toArray(val)
  countries.forEach(country => {
    country.searchableString = `${country.dialling_code}${country.name_en.toLowerCase()}${country.name_sv.toLowerCase()}`
    country.isEnriched = true
  })
}

const enrichCustomerCreditTimelineItem = function (val) {
  const customerCreditTimelineItems = toArray(val)
  customerCreditTimelineItems.forEach(customerCreditTimelineItem => {
    customerCreditTimelineItem.paymentMethod = store.state.posCheckout.paymentMethods.find(pm => pm.id === customerCreditTimelineItem.payment_method_id)
    customerCreditTimelineItem.date = window.dayjs.parseServerDateTime(customerCreditTimelineItem.date)
    customerCreditTimelineItem.isEnriched = true
  })
}

const enrichPosition = function (val) {
  const positions = toArray(val)
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  positions.forEach(position => {
    position.category = store.state.position.categories.find(cat => cat.id === position.category_id)
    position.map_x = parseFloat(position.map_x)
    position.map_y = parseFloat(position.map_y)
    position.width_percent = `${(position.width * 100)}%`
    position.height_percent = `${(position.height * 100)}%`
    position.border_radius_percent = (position.border_radius * 100) + '%'
    position.svg_rect_id = `O-rect-${position.id}`
    position.svg_rect_rx = (position.border_radius * position.width * 100) + '%'
    position.svg_rect_clip_path_id = `O-clip-${position.id}`
    position.svg_rect_clip_path_href = `#O-rect-${position.id}`
    position.svg_clip_path_id = `O-inner-clip-${position.id}`
    position.svg_text_x = (position.width * 50) + '%'
    position.svg_text_y = ((position.height * 53) + (isSafari ? 0.45 : 0)) + '%'
    position.svg_text_clip_path = `url(#O-clip-${position.id})`
    position.svg_polygon_clip_path = `url(#O-inner-clip-${position.id})`
    position.isEnriched = true
  })
}

const enrichBankgiroImport = function (val) {
  const bankgiroImports = toArray(val)
  window.conversion.convertDates('BankgiroImport', bankgiroImports)
  bankgiroImports.forEach(bankgiroImport => {
    bankgiroImport.bankgiro_payments.forEach(bankgiroPayment => {
      this.enrichCustomer(bankgiroPayment.suggested_customers)
      if (bankgiroPayment.payment) {
        this.enrichCustomer(bankgiroPayment.payment.customer)
        bankgiroPayment.payment.payment_applications.forEach(paymentApplication => {
          this.enrichInvoice(paymentApplication.applicable)
        })
      }
    })
    bankgiroImport.isEnriched = true
  })
}

const enrichCategory = function (val) {
  const categories = toArray(val)
  categories.forEach(category => {
    Object.assign(category, require('@/mixins/category.js').default)
    category.lodgingTypes = store.state.position.lodgingTypes.filter(type => category.lodging_type_ids.includes(type.id))
    category.cancellationPolicies = store.state.cancellationPolicy.cancellationPolicies.filter(policy => category.cancellation_policy_ids.includes(policy.id))
    category.positions = store.state.position.positions.filter(pos => pos.category_id === category.id)
    category.defaultLodgingType = store.state.position.lodgingTypes.find(type => type.id === category.default_lodging_type_id)
    category.product = store.state.product.products.find(prod => prod.id === category.product_id)
    category.seasonProduct = store.state.product.products.find(prod => prod.id === category.season_product_id)
    category.slug = window.conversion.slugify(`${category.name}}`)
    if (category.electricity) {
      Object.assign(category.electricity, require('@/mixins/electricity.js').default)
    }
    category.isEnriched = true
  })
}

const enrichSeason = function (val) {
  const seasons = toArray(val)
  window.conversion.convertDates('Season', seasons)
  seasons.forEach(season => {
    Object.assign(season, require('@/mixins/season.js').default)
    const diffInDays = window.conversion.diffInDays(season.start, season.end)
    season.subtitle = `${season.start.format('ddd D MMM YYYY')} - ${season.end.format('ddd D MMM YYYY')} (${diffInDays})`
    season.isEnriched = true
  })
}

const enrichCustomer = function (val) {
  const customers = toArray(val)
  customers.forEach(customer => {
    const country = store.state.staticData.countries.find(country => country.id === customer.country_id)
    Vue.set(customer, 'country', country)
    const diallingCodeCountry = store.state.staticData.countries.find(country => country.id === customer.dialling_code_country_id)
    Vue.set(customer, 'diallingCodeCountry', diallingCodeCountry)

    if (customer.diallingCodeCountry && customer.phone_number) {
      Vue.set(customer, 'fullPhoneNumber', `${customer.diallingCodeCountry.dialling_code} ${customer.phone_number}`)
    } else {
      Vue.set(customer, 'fullPhoneNumber', '')
    }

    let shortAddress = ''
    if (customer.street_name) {
      shortAddress += customer.street_name
      if (customer.street_number) {
        shortAddress += ' ' + customer.street_number + ', '
      } else {
        shortAddress += ', '
      }
    }
    if (customer.city) {
      shortAddress += customer.city + ', '
    }
    if (customer.country) {
      shortAddress += customer.country.name
    }

    if (customer.is_org && customer.org_reference) {
      Vue.set(customer, 'fullNameWithRef', `${customer.full_name} (${customer.org_reference})`)
    } else {
      Vue.set(customer, 'fullNameWithRef', customer.full_name)
    }

    Vue.set(customer, 'shortAddress', shortAddress)

    Vue.set(customer, 'isEnriched', true)
    Vue.set(customer, '_tag', 'EnrichedCustomer')
  })
}

const enrichProduct = function (val) {
  const products = toArray(val)
  window.conversion.convertDates('Product', products)
  products.forEach(product => {
    if (!product.productGroup) {
      const productGroup = store.state.product.productGroups.find(productGroup => productGroup.id === product.product_group_id)
      Vue.set(product, 'productGroup', productGroup)
    }
    product.isEnriched = true
  })
}

const enrichProductGroup = function (val) {
  const productGroups = toArray(val)
  productGroups.forEach(productGroup => {
    const productGroupProducts = store.state.product.products.filter(product => product.product_group_id === productGroup.id)
    Vue.set(productGroup, 'products', productGroupProducts)
    productGroup.isEnriched = true
  })
}

const enrichProductLayoutTab = function (val) {
  const productLayoutTabs = toArray(val)
  productLayoutTabs.forEach(productLayoutTab => {
    let maxRow = 1
    productLayoutTab.product_layout_buttons.forEach(productLayoutButton => {
      productLayoutButton.products = store.state.product.products.filter(product => productLayoutButton.product_ids.includes(product.id))
      maxRow = Math.max(maxRow, productLayoutButton.row)
    })
    productLayoutTab.row_count = Math.max((maxRow + 1), 7) // row_count = sista rad med en knapp (+1), men minst 7, döpte den till row_count istället för rowCount eftersom objektet har attributet column_count från databasen
    Vue.set(productLayoutTab, 'matrix', {})
    for (let y = 1; y <= productLayoutTab.row_count; y++) {
      const column = {}
      for (let x = 1; x <= productLayoutTab.column_count; x++) {
        const button = productLayoutTab.product_layout_buttons.find(p => p.column === x && p.row === y)
        if (store.state.product.isLoadingSaveLayoutButtonButtons.find(btn => btn.product_layout_tab_id === productLayoutTab.id && btn.row === y && btn.column === x) != null) {
          column[x] = 'loading'
        } else if (!button) {
          column[x] = null
        } else if (button.type === 'button' || button.type === 'menu') {
          column[x] = button
        } else {
          // Ska normalt inte gå hit
          column[x] = null
        }
      }
      Vue.set(productLayoutTab.matrix, y, column) // För att göra det reaktivt
    }
    productLayoutTab.slug = window.conversion.slugify(`${productLayoutTab.id}-${productLayoutTab.title}`)
    productLayoutTab.isEnriched = true
  })
}

const enrichPaymentTerm = function (val) {
  const paymentTerms = toArray(val)
  paymentTerms.forEach(paymentTerm => {
    Object.assign(paymentTerm, require('@/mixins/paymentTerm.js').default)
  })
}

const enrichOrder = function (val) {
  const orders = toArray(val)
  window.conversion.convertDates('ParkedOrder', orders)
  orders.forEach(order => {
    Object.assign(order, require('@/mixins/order.js').default)
    enrichCharge(order.charges)
    order.total = order.getTotal()
    order.isEnriched = true
  })
}

const enrichCharge = function (val) {
  const charges = toArray(val)
  window.conversion.convertDates('Charge', charges)
  charges.forEach(charge => {
    // appendar product om charge inte redan har product, i regel borde det appendas på servern eftersom client bara har icke-borttagna produkter
    if (!charge.product) {
      charge.product = store.state.product.products.find(prod => prod.id === charge.product_id)
    }
    charge.isEnriched = true
  })
}

const getPaymentMethodLabel = function ({ paymentMethod, surfboardOrder, isCustomerCreditApplication = false }) {
  if (isCustomerCreditApplication) {
    return 'Tillgodo'
  }
  if (surfboardOrder) {
    // För Swish-betalningar via Surfboard så skriver vi ut specifikt Surfboard eftersom det också finns en PaymentMethod med samma namn
    if (surfboardOrder.payment_method_name === 'Swish') {
      return 'Swish (Surfboard Payments)'
    }
    return surfboardOrder.payment_method_name
  }
  return paymentMethod?.name || '-'
}

const enrichReceiptPayment = function (val) {
  const receiptPayments = toArray(val)
  window.conversion.convertDates('ReceiptPayment', receiptPayments)
  receiptPayments.forEach(receiptPayment => {
    if (receiptPayment.receipt) {
      enrichReceipt(receiptPayment.receipt)
    }
    const isCustomerCreditApplication = !!receiptPayment.is_customer_credit_application
    const paymentMethod = receiptPayment.payment_method
    const surfboardOrder = receiptPayment.surfboard_order
    receiptPayment.amountFormatted = window.conversion.toHumanReadableAmount(receiptPayment.paid_amount / 100)
    receiptPayment.paidAtFormatted = receiptPayment.created_at ? receiptPayment.created_at.toHumanReadableDate() : ''
    receiptPayment.paymentMethodLabel = getPaymentMethodLabel({ paymentMethod, surfboardOrder, isCustomerCreditApplication })
    receiptPayment.iconClassName = isCustomerCreditApplication ? 'mdi-account-cash-outline' : paymentMethod?.icon_class_name
    receiptPayment.color = isCustomerCreditApplication ? 'secondary' : paymentMethod?.default_gui_color
    receiptPayment.documentLabel = receiptPayment.receipt?.receipt_serial ? `#${receiptPayment.receipt.receipt_serial}` : `#${receiptPayment.receipt_id}`
    receiptPayment.isRefunded = surfboardOrder?.refunded_at !== null && surfboardOrder?.refunded_at !== undefined
    receiptPayment.refundedAtFormatted = receiptPayment.isRefunded ? surfboardOrder.refunded_at.toHumanReadableDate() : ''
    receiptPayment.isEnriched = true
  })
}

const enrichInvoicePaymentApplication = function (val) {
  const invoicePaymentApplications = toArray(val)
  window.conversion.convertDates('InvoicePaymentApplication', invoicePaymentApplications)
  invoicePaymentApplications.forEach(invoicePaymentApplication => {
    if (invoicePaymentApplication.applicable) {
      enrichInvoice(invoicePaymentApplication.applicable)
    }
    if (invoicePaymentApplication.invoice) {
      enrichInvoice(invoicePaymentApplication.invoice)
    }
    if (invoicePaymentApplication.credit_invoice) {
      enrichInvoice(invoicePaymentApplication.credit_invoice)
    }
    const isCustomerCreditApplication = !!invoicePaymentApplication.is_customer_credit_application
    const paymentMethod = invoicePaymentApplication.payment?.payment_method
    const surfboardOrder = invoicePaymentApplication.payment?.surfboard_order
    const paidAt = isCustomerCreditApplication ? invoicePaymentApplication.applied_at : invoicePaymentApplication.payment?.paid_at

    invoicePaymentApplication.paidAt = paidAt
    invoicePaymentApplication.amountFormatted = window.conversion.toHumanReadableAmount(invoicePaymentApplication.paid_amount / 100)
    invoicePaymentApplication.paidAtFormatted = paidAt ? paidAt.toHumanReadableDate() : ''
    invoicePaymentApplication.deletedAtFormatted = invoicePaymentApplication.deleted_at ? invoicePaymentApplication.deleted_at.toHumanReadableDate() : ''
    invoicePaymentApplication.paymentMethodLabel = getPaymentMethodLabel({ paymentMethod, surfboardOrder, isCustomerCreditApplication })
    invoicePaymentApplication.iconClassName = isCustomerCreditApplication ? 'mdi-account-cash-outline' : paymentMethod?.icon_class_name
    invoicePaymentApplication.color = isCustomerCreditApplication ? 'secondary' : paymentMethod?.default_gui_color
    invoicePaymentApplication.documentLabel = `#${invoicePaymentApplication.applicable_id}`
    invoicePaymentApplication.isRefunded = surfboardOrder?.refunded_at !== null && surfboardOrder?.refunded_at !== undefined
    invoicePaymentApplication.refundedAtFormatted = invoicePaymentApplication.isRefunded ? surfboardOrder.refunded_at.toHumanReadableDate() : ''
    invoicePaymentApplication.isEnriched = true
  })
}

const enrichReceipt = function (val) {
  const receipts = toArray(val)
  window.conversion.convertDates('Receipt', receipts)
  receipts.forEach(receipt => {
    // VIKTIGT: vi får anta att product på receipt kan vara raderad, client känner bara till icke raderade produkter, så server får appenda product på charges istället
    receipt.totalFormatted = window.conversion.toHumanReadableAmount(receipt.total / 100)
    receipt.createdAtFormatted = receipt.created_at.format('D MMM YYYY HH:mm')
    if (receipt.customer) {
      enrichCustomer(receipt.customer)
    }
    receipt.isEnriched = true
  })
}

const enrichEmail = function (val) {
  const emails = toArray(val)
  window.conversion.convertDates('Email', emails)
  emails.forEach(email => {
    email.is_opened = !!email.opened_at
    email.is_sent = !!email.sent_at
    email.isEnriched = true
  })
}

const enrichBookExport = function (val) {
  const bookExports = toArray(val)
  window.conversion.convertDates('BookExport', bookExports)
  bookExports.forEach(bookExport => {
    bookExport.isEnriched = true
  })
}

const enrichCalendarItem = function (val) {
  const calendarItems = toArray(val)
  window.conversion.convertDates('CalendarItem', calendarItems)
  calendarItems.forEach(calendarItem => {
    calendarItem.is_mid_booking_inclusive = calendarItem.is_mid_booking || calendarItem.is_checkin_day || calendarItem.is_checkout_day
    if (calendarItem.accommodation_charge) {
      calendarItem.accommodation_charge.position = store.state.position.positions.find(pos => pos.id === calendarItem.accommodation_charge.position_id) // OBS: platsen kan vara borttagen
      calendarItem.accommodation_charge.product = store.state.product.products.find(prod => prod.id === calendarItem.accommodation_charge.product_id) // OBS: produkten kan vara borttagen
      calendarItem.accommodation_charge.nights = calendarItem.accommodation_charge.end.diff(calendarItem.accommodation_charge.start, 'days')
    }
    if (calendarItem.suggested_accommodation_charge) {
      calendarItem.suggested_accommodation_charge.position = store.state.position.positions.find(pos => pos.id === calendarItem.suggested_accommodation_charge.position_id) // OBS: platsen kan vara borttagen
      calendarItem.suggested_accommodation_charge.product = store.state.product.products.find(prod => prod.id === calendarItem.suggested_accommodation_charge.product_id) // OBS: produkten kan vara borttagen
      calendarItem.suggested_accommodation_charge.nights = calendarItem.suggested_accommodation_charge.end.diff(calendarItem.suggested_accommodation_charge.start, 'days')

      if (calendarItem.suggested_accommodation_charge.nights === 1) {
        const startDate = calendarItem.suggested_accommodation_charge.start.format('D MMM YYYY')
        calendarItem.suggested_accommodation_charge.text_line_1 = `${calendarItem.suggested_accommodation_charge.price / 100}kr, ${startDate}`
      } else {
        const startDate = calendarItem.suggested_accommodation_charge.start.format('D MMM YYYY')
        const endDate = calendarItem.suggested_accommodation_charge.end.format('D MMM YYYY')
        calendarItem.suggested_accommodation_charge.text_line_1 = `${calendarItem.suggested_accommodation_charge.price / 100}kr, ${startDate} - ${endDate}`
      }

      if (calendarItem.suggested_accommodation_charge.position) {
        calendarItem.suggested_accommodation_charge.text_line_2 = `${calendarItem.suggested_accommodation_charge.note}, ${calendarItem.suggested_accommodation_charge.position.full_name}`
      } else {
        calendarItem.suggested_accommodation_charge.text_line_2 = `${calendarItem.suggested_accommodation_charge.note}`
      }
    }
    calendarItem.isEnriched = true
  })
}

const enrichPositionBlock = function (val) {
  const positionBlocks = toArray(val)
  window.conversion.convertDates('PositionBlock', positionBlocks)
  positionBlocks.forEach(positionBlock => {
    positionBlock.position = store.state.position.positions.find(pos => pos.id === positionBlock.position_id)
    positionBlock.closingDateFormatted = positionBlock.closing_date.toHumanReadableDate()
    positionBlock.openingDateFormatted = positionBlock.opening_date.toHumanReadableDate()
    positionBlock.isEnriched = true
  })
}

const enrichSalesReport = function (val) {
  const salesReports = toArray(val)
  window.conversion.convertDates('SalesReport', salesReports)
  salesReports.forEach(salesReport => {
    salesReport.title = salesReport.sales_source === 'total' ? 'Total försäljning' : salesReport.sales_source === 'invoicing' ? 'Fakturerad försäljning' : `Kassaregister ${salesReport.register_name}`
    salesReport.isEnriched = true
  })
}

const enrichUser = function (val) {
  const users = toArray(val)
  users.forEach(user => {
    const diallingCodeCountry = store.state.staticData.countries.find(country => country.id === user.dialling_code_country_id)
    Vue.set(user, 'diallingCodeCountry', diallingCodeCountry)
    user.isEnriched = true
  })
}

const enrichReservation = function (val) {
  const reservations = toArray(val)
  window.conversion.convertDates('Reservation', reservations)
  reservations.forEach(reservation => {
    if (reservation.booking) {
      enrichBooking(reservation.booking)
    }
    if (reservation.customer) {
      enrichCustomer(reservation.customer)
    }
    reservation.isEnriched = true
  })
}

export default {
  enrichBooking,
  enrichBookingGroup,
  enrichInvoice,
  enrichPosition,
  enrichCountry,
  enrichCategory,
  enrichCustomer,
  enrichEmail,
  enrichProduct,
  enrichProductGroup,
  enrichProductLayoutTab,
  enrichPaymentTerm,
  enrichOrder,
  enrichCharge,
  enrichReceiptPayment,
  enrichInvoicePaymentApplication,
  enrichReceipt,
  enrichCalendarItem,
  enrichPositionBlock,
  enrichSalesReport,
  enrichBankgiroImport,
  enrichBookExport,
  enrichCustomerCreditTimelineItem,
  enrichSeason,
  enrichUser,
  enrichReservation
}
